module.exports = __webpack_public_path__ + "static/media/check-circle-icon.fa1b8de4.svg";